import { CircularProgressbar } from "react-circular-progressbar";
import styles from "./styles.module.scss";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { trackUserEvent } from "@utils/updateDataLayer";
import { ReviewSlider } from "src/routes/onboarding/shared/components/reviewsSlider";
import { useOnboardingTexts } from "src/routes/onboarding/shared/hooks/useOnboardingTexts";

export const CreatingPlan = () => {
  const [progress, setProgress] = useState(0);

  const { getSectionText } = useOnboardingTexts();

  const title = getSectionText("creating").title;

  const navigate = useNavigate();

  useEffect(() => {
    const updateProgress = () => {
      setProgress((prevProgress) => {
        if (prevProgress < 100) {
          const randomIncrease = Math.floor(Math.random() * 11) + 5;
          const nextProgress = prevProgress + randomIncrease;

          if (nextProgress >= 100) {
            clearTimeout(intervalId);
            trackUserEvent("", {
              screenId: "Creating",
              screenTitle: title,
            });
            navigate("/take-step");
            return 100;
          }
          return nextProgress;
        } else {
          clearTimeout(intervalId);
          return 100;
        }
      });
    };
    const randomDelay = Math.floor(Math.random() * 801) + 200;
    const intervalId = setTimeout(updateProgress, randomDelay);

    return () => clearTimeout(intervalId);
  }, [progress, navigate, title]);

  return (
    <div className={styles.container} id="breakdown">
      <div className={styles.progress}>
        <CircularProgressbar
          strokeWidth={4}
          styles={{
            trail: {
              color: "#F8F8F8",
              stroke: "#F8F8F8",
            },
            root: {
              borderRadius: "50%",
              backgroundColor: "white",
            },
            path: {
              stroke: "var(--primary)",
              color: "var(--primary)",
            },
            text: {
              fontWeight: "700",
              fill: "black",
              fontSize: "18px",
            },
          }}
          value={progress}
          text={`${progress}%`}
        />
      </div>
      <div className={styles.subtitle}>{title}</div>
      <div className={styles.reviewContainer}>
        <div className={styles.people}>
          <h2>4,280,000+ users</h2>
          <p>Has chosen us</p>
        </div>
        <ReviewSlider />
      </div>
    </div>
  );
};
